import { Injectable } from "@angular/core";
import { Http, Response, Headers, RequestOptions } from "@angular/http";
import { Observable } from "rxjs/Observable";
import { AuthService } from "./../../shared/models/auth.service";
import { WeGoConfig, IAPIResponse, DataListModel } from "../../shared/config";
import { RoleModel } from "./role.model";

@Injectable()
export class RoleService {
  constructor(private authService: AuthService, private http: Http) {}

  public GetRoleList(input?: DataListModel): Observable<IAPIResponse> {
    let getRoleUrl = WeGoConfig.API_GET_ROLE_LIST;
    let queryString = this.authService.HandleAPIListInput(input);
    if (queryString) {
      getRoleUrl = getRoleUrl + "?" + queryString;
    }
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getRoleUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public ExportRoleList(input?: DataListModel): any {
    input.currentPage = 0;
    let queryString = this.authService.HandleAPIListInput(input);
    let getUrl = WeGoConfig.API_EXPORT_ROLE_LIST + "?" + queryString;
    let headers = this.authService.GetHeader("text/csv");
    let options = new RequestOptions({ headers: headers });
    return this.http.get(getUrl, options);
  }

  public GetRoleByHashId(roleHashId: string): Observable<IAPIResponse> {
    let getRoleUrl =
      WeGoConfig.API_GET_ROLE_BY_HASH + "?roleHashId=" + roleHashId;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getRoleUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public AddRole(roleModel: RoleModel): Observable<IAPIResponse> {
    let body = roleModel;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    return this.http
      .post(WeGoConfig.API_POST_ROLE_DETAIL, body, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetEntityDropdownList(input?: DataListModel): Observable<IAPIResponse> {
    let getUrl = WeGoConfig.API_GET_ENTITY_LIST;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetRoleDropdownListByEntity(entity: string): Observable<IAPIResponse> {
    let getUrl = WeGoConfig.API_GET_ROLE_LIST_BY_ENTITY + "?entity=" + entity;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetAccessibilityMatrixByRoleHashId(roleHashId: string): Observable<IAPIResponse> {
    let getUrl = WeGoConfig.API_GET_ACCESSIBILITY_BY_HASH + "?roleHashId=" + roleHashId;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public DeleteRole(roleHashId: string): Observable<IAPIResponse> {
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    return this.http.get(WeGoConfig.API_POST_DELETE_ROLE + "?roleHashId=" + roleHashId, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/role-management/models/role.service.ts